import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Import styles
import './styles/globals.css';

// Import generated route tree
import { routeTree } from './routeTree.gen';

// Create router instance
const router = createRouter({ routeTree });

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Create query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

// 003: bank suggestions depend on receipts/invoices changed elsewhere (uploads, OCR
// pipeline, corrections). Never serve them from the 5-minute cache: refetch on every
// mount and window focus.
queryClient.setQueryDefaults(['bank'], { staleTime: 0, refetchOnMount: 'always', refetchOnWindowFocus: true });

// Get root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Render app
createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>
);
